import { DashboardLayoutObject } from 'src/models/dashboard/_types';
import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

export const fetchKpiBlueprints: () => Promise<
  DashboardLayoutObject[]
> = async () => {
  const response = await api.get('/api/v4/business_reports/kpi_options');
  const kpis = response.data.map((kpi) => camelcaseKeys(kpi, { deep: true }));
  return kpis;
};

export const fetchChartBlueprints: () => Promise<
  DashboardLayoutObject[]
> = async () => {
  const response = await api.get('/api/v4/business_reports/chart_options');
  const charts = response.data.map((chart) =>
    camelcaseKeys(chart, { deep: true })
  );
  return charts;
};

interface FetchSalesOptions {
  per: number;
  page: number;
  q: {
    has_coupon?: string;
    'has_item[]'?: string[] | null[];
    user_formatted_name_or_user_email_cont?: string;
  };
  start_date: number;
  end_date: number;
}

export const fetchSales = async ({
  per,
  page,
  q,
  start_date,
  end_date,
}: FetchSalesOptions) => {
  const params = {
    per,
    page,
    q,
    start_date,
    end_date,
  };

  const response = await api.get(`/api/v4/business_reports/sales`, { params });

  return response.data;
};

interface PayoutAccount {
  id: string;
  name: string;
}

interface PayoutData {
  id: string;
  type: string;
  amount: number;
  method: string;
  object: string;
  status: string;
  created: number;
  currency: string;
  livemode: boolean;
  metadata: Record<string, any>;
  automatic: boolean;
  description: string | null;
  destination: string;
  reversed_by: string | null;
  source_type: string;
  arrival_date: number;
  failure_code: string | null;
  failure_message: string | null;
  original_payout: string | null;
  balance_transaction: string;
  statement_descriptor: string;
  failure_balance_transaction: string | null;
  account: PayoutAccount;
}

interface Payout {
  data: PayoutData;
  account_id: string;
  id: null;
}

export const fetchRecentPayouts = async (): Promise<Payout[]> => {
  const response = await api.get('/api/v4/business_reports/recent_payouts');
  return camelcaseKeys(response.data) as Payout[];
};
